const state = () => ({
	userAuthList : null,
	brandList : null,
	siteGroupList : null,
	storeList : null,
	storeAuthList : null,
	productTypeList : null,
	productCodeList : null,
	productSnList : null
});

const getters = {
	getUserAuthList: state => state.userAuthList,
	getBrandList: state => state.brandList,
	getSiteGroupList: state => state.siteGroupList,
	getStoreList: state => state.storeList,
	getStoreAuthList: state => state.storeAuthList,
	getProductTypeList: state => state.productTypeList,
	getProductCodeList: state => state.productCodeList,
	getProductSnList: state => state.productSnList,
};

const actions = {

	setUserAuthList({ commit }, listData) {
    commit('SET_USER_AUTH_LIST' , listData);
	},
	setBrandList({ commit }, listData) {
    commit('SET_BRAND_LIST' , listData);
	},
	setSiteGroupList({ commit }, listData) {
    commit('SET_SITE_GROUP_LIST' , listData);
	},
	setStoreList({ commit }, listData) {
    commit('SET_STORE_LIST' , listData);
	},
	setStoreAuthList({ commit }, listData) {
    commit('SET_STORE_AUTH_LIST' , listData);
	},
	setProductTypeList({ commit }, listData) {
    commit('SET_PRODUCT_TYPE_LIST' , listData);
	},
	setProductCodeList({ commit }, listData) {
    commit('SET_PRODUCT_CODE_LIST' , listData);
	},
	setProductSnList({ commit }, listData) {
		commit('SET_PRODUCT_SN_LIST' , listData);
	},
};

const mutations = {
	SET_USER_AUTH_LIST(state, payload) {
		state.userAuthList = payload;
	},
	SET_BRAND_LIST(state, payload) {
		state.brandList = payload;
	},
	SET_SITE_GROUP_LIST(state, payload) {
		state.siteGroupList = payload;
	},
	SET_STORE_LIST(state, payload) {
		state.storeList = payload;
	},
	SET_STORE_AUTH_LIST(state, payload) {
		state.storeAuthList = payload;
	},
	SET_PRODUCT_TYPE_LIST(state, payload) {
		state.productTypeList = payload;
	},
	SET_PRODUCT_CODE_LIST(state, payload) {
		state.productCodeList = payload;
	},
	SET_PRODUCT_SN_LIST(state, payload) {
		state.productSnList = payload;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
